/** 
 * This info was found outside of Swiper docs, so please remember it:
 * swiper.size === .swiper width (margins included)
 * swiper.virtualSize === .swiper-wrapper width
 * 
 * as I understand it, swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter
 * 
 * Important : For it to work, you can't use property `slidesOffsetAfter`
 */
export const toggleSwiperLock = (swiper, bonusMargins = 0) => {
    /*
    let refWidth = 0
    if (bonusMargins) {
        const count = parseInt( window.getComputedStyle(swiper.el).getPropertyValue('--cards--count') )
        const width = parseInt( window.getComputedStyle(swiper.el).getPropertyValue('--card--width') )
        const gap = parseInt( window.getComputedStyle(swiper.el).getPropertyValue('--cards--gap') )
        
        const myWrapperWidth = count * width + (count - 1) * gap
        const refWidth = myWrapperWidth + bonusMargins
        
        console.table({
            windowInnerWidth: window.innerWidth,
            swiperSize: swiper.size,
            swiperVirtualSize: swiper.virtualSize,
            bonusMargins: bonusMargins,
            cardsFlexBasis: swiper.el.style.getPropertyValue('--cards--flex-basis'),
            count: count,
            width: width,
            gap: gap,
            myWrapperWidth: myWrapperWidth,
            refWidth: refWidth,
        })
    }
    */
    /*
    const shouldBeLocked = (
        swiper.size === Math.floor(swiper.virtualSize)
     && window.innerWidth > refWidth
    )
    */
    
    const shouldBeLocked = swiper.size === Math.floor(swiper.virtualSize)
    
    
    /* debug log:*/
    
    // console.log('swiper', 
    //     (shouldBeLocked ? 'should be locked' : 'should be unlocked'), 
    //     Math.floor(swiper.virtualSize), '/', swiper.size)
    
    // console.log({
    //     swiperWidthMarginsIncluded: swiper.size,
    //     swiperWrapperWidth: swiper.virtualSize
    // })
    
    
    swiper.el.classList.toggle('locked', shouldBeLocked)
    swiper.wrapperEl.classList.toggle('locked', shouldBeLocked)
    shouldBeLocked ? swiper.disable() : swiper.enable()
    
    return shouldBeLocked
}